import React, { createContext, useState} from 'react'   
import useAxios from "../api/useAxios" 

import { useSearchParams} from 'react-router-dom';
 
import { toast } from 'react-toastify';

const CreditMemoContext = createContext()

export default CreditMemoContext; 
export const CreditMemoProvider = ({children}) => {   

    const [searchParams, setSearchParams] = useSearchParams({} , {replace:true}); 

    let [page, setPage] = useState(1)
    let [limit, setLimit] = useState(50)

    let api = useAxios() 


    let fetchData = async() =>{ 
        const params = Object.fromEntries([...searchParams]); 
        let response  = await api.get(`/manager/credit_memo?sort_by=orderId`, { 
            params, 
        });     
        if(response.status === 200){   
            return response.data  
        } 
    }

    let markAsRecived = async(credit_memo_id) => { 
        const data = { "value": true }
        api.put(`/manager/credit_memo/${credit_memo_id}/received_by_vendor`,data)
        .then(response => {   
            toast.success(`Order ${credit_memo_id} mark as recived`, {
                position: "top-right",
                autoClose:3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0,
            });
            
            const element = document.getElementById(`cm-marker-${credit_memo_id}`)
                  element.classList.add("success"); 
        })  
        .catch(error => {
            toast.error(`Something went wrong!`, {
                position: "top-right",
                autoClose:3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: 0,
            });
        }); 
    }


    let contextCreditMemoData = {
        page:page,
        setPage:setPage,
        limit:limit,
        setLimit:setLimit,
        fetchData:fetchData,
        markAsRecived:markAsRecived,
    }

return(
    <CreditMemoContext.Provider value={contextCreditMemoData}> 
        {children}  
    </CreditMemoContext.Provider>
    )
}